import React, { useEffect } from "react";
import "./Home.scss";
import { connect } from "react-redux";

import { Button } from "@chakra-ui/react";
import { Search2Icon, ChevronRightIcon } from "@chakra-ui/icons";

import { useNavigate } from "react-router-dom";

const HOME_TOP_TEXT1 = "Get work done. Get ahead.";
const HOME_TOP_TEXT2 = "Get connected with Workoza.";

const HOME_TOP_SUBTEXT1 =
  "Workoza makes employee growth and career advancement easier and more transparent than ever before.";
const HOME_TOP_SUBTEXT2 =
  "As Canada’s IT staffing agency, we put in the work so our partners will prosper.";

const HOMEPAGE_INFO = [
  {
    id: "VISION_TALENT",
    title: [
      {
        id: "title1",
        label: "Your Vision,",
      },
      {
        id: "title2",
        label: "Our IT Talent",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "You've got big ideas and ambitious deliverables.",
      },
      {
        id: "par2",
        text: "We've got people ready to bring them to life. From development to management, analytics to quality assurance, Workoza has IT covered.",
      },
      {
        id: "par3",
        text: "We offer contract staffing to get you through crunch times and direct hire services to craft your ideal tech team.",
      },
    ],
    img: `/homepage_image1.jpeg`,
    imgAlt: `under maintainance`,
  },
  {
    id: "CAREER_COMMITMENT",
    title: [
      {
        id: "title1",
        label: "Your IT Career,",
      },
      {
        id: "title2",
        label: "Our Commitment.",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "Without surprises, things work better.",
      },
      {
        id: "par2",
        text: "We're always upfront about job details, pay rates, and client scenarios. Your priorities always come first.",
      },
    ],
    img: `/homepage_image2.jpeg`,
    imgAlt: `under maintainance`,
  },
];

const HOMEPAGE_SOLUTIONS = [
  {
    id: "TECH_TEAM",
    title: [
      {
        id: "title1",
        label: "Blending tech and team for better outcomes.",
      },
    ],
    paragraphs: [
      {
        id: "par1",
        text: "By focusing on connections, Workoza aims to build a more personal and professional staffing experience.",
      },
      {
        id: "par2",
        text: "We get to know the real you, then our tech forward process kicks in to make the match.",
      },
    ],
    img: "/homepage_solution.jpeg",
    imgAlt: `under maintainance`,
  },
];

const HOME_FIND_JOB = [
  {
    id: "par1",
    paragraphs: [
      {
        id: "par1",
        text: "A connected community makes all the difference.",
      },
      {
        id: "par2",
        text: "Just imagine where it can take you.",
      },
    ],
  },
];

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const navigate = useNavigate();

  const renderHomeImageTopBar = () => {
    return (
      <div className="homeTopContainer">
        <div className="homeTopbarHeadingContainer">
          <div className="homeTopbarHeadingText">{HOME_TOP_TEXT1}</div>
          <div className="homeTopbarHeadingText">{HOME_TOP_TEXT2}</div>
        </div>
        <div className="homeTopbarSubHeadingContainer">
          <div className="homeTopbarSubHeadingText">{HOME_TOP_SUBTEXT1}</div>
          <div className="homeTopbarSubHeadingText">{HOME_TOP_SUBTEXT2}</div>
        </div>
      </div>
    );
  };

  const renderHomeFeed = () => {
    return HOMEPAGE_INFO.map((info) => {
      const { id, title, paragraphs, img, imgAlt } = info;

      const renderHomeFeedTitle = () => {
        return title.map(({ id, label }) => {
          return <div className="homeFeedTitleText">{label}</div>;
        });
      };

      const renderHomeFeedParagraphs = () => {
        return paragraphs.map(({ id, text }) => {
          return <div className="homeFeedParagraphText">{text}</div>;
        });
      };

      return (
        <div className="homeFeedWrapper" key={id}>
          <div className="homeFeedImageContainer">
            <img src={img} alt={imgAlt} />
          </div>
          <div className="homeFeedTextContainer">
            <div className="homeFeedTextTitleContainer">
              {renderHomeFeedTitle()}
            </div>
            <div className="homeFeedTextParagraphsContainer">
              {renderHomeFeedParagraphs()}
            </div>
          </div>
        </div>
      );
    });
  };

  const renderHomeSolutionFeed = () => {
    return HOMEPAGE_SOLUTIONS.map((solution) => {
      const { id, title, paragraphs } = solution;

      const renderHomeSoltionTitle = () => {
        return title.map(({ id, label }) => {
          return <div className="homeFeedTitleText">{label}</div>;
        });
      };

      const renderHomeFeedParagraphs = () => {
        return paragraphs.map(({ id, text }) => {
          return <div className="homeFeedParagraphText">{text}</div>;
        });
      };

      return (
        <div className="homeSolutionWrapper" key={id}>
          <div className="homeSolutionTextContainer">
            <div className="homeFeedTitleText">{renderHomeSoltionTitle()}</div>
            <div className="homeFeedTextParagraphsContainer">
              {renderHomeFeedParagraphs()}
            </div>
          </div>
        </div>
      );
    });
  };

  const renderHomeFindJobFeed = () => {
    const { paragraphs } = HOME_FIND_JOB[0];

    const handleFindJobClick = () => {
      navigate(`/careers`);
    };

    const renderFindJobParagraph = () => {
      return paragraphs.map(({ id, text }) => {
        return (
          <div className="homeFindJobParagraphText" key={id}>
            {text}
          </div>
        );
      });
    };

    return (
      <div className="homeFindJobWrapper">
        <div className="homeFindJobParagraphContainer">
          {renderFindJobParagraph()}
        </div>
        <Button
          leftIcon={<Search2Icon />}
          rightIcon={<ChevronRightIcon />}
          onClick={handleFindJobClick}
          colorScheme="red"
          size="lg"
        >
          Search Jobs
        </Button>
      </div>
    );
  };

  return (
    <div className="homeContainer">
      <div className="homeWrapper">
        {renderHomeImageTopBar()}
        {renderHomeFeed()}
        {renderHomeSolutionFeed()}
        {renderHomeFindJobFeed()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state,
  };
};

export default connect(mapStateToProps)(Home);
